import { ROLES } from '../../../Permission'
import { ColumnsType } from 'antd/es/table'
import { TCommunityUser } from './types'
import { ColumnType } from 'antd/es/table/interface'

export const filterColumns = (
  selectedRole: string | null,
  columns: ColumnsType<TCommunityUser>
) =>
  selectedRole
    ? columns.filter((i: ColumnType<TCommunityUser>) => {
        switch (i.dataIndex) {
          case 'departments':
            return selectedRole === ROLES.HOSPITAL_USER
          case 'hospital':
            return (
              selectedRole === ROLES.HOSPITAL_USER ||
              selectedRole === ROLES.HOSPITAL_ADMIN
            )
          case 'contract_categories':
            return (
              selectedRole === ROLES.HOSPITAL_USER ||
              selectedRole === ROLES.CONTRACT_STEWARD ||
              selectedRole === ROLES.VICE_PRESIDENT ||
              selectedRole === ROLES.LEGAL ||
              selectedRole === ROLES.ANALYST ||
              selectedRole === ROLES.CLINICAL_COORDINATOR
            )
          default:
            return true
        }
      })
    : columns
